const ACCOUNTGRADE = ["Sales Representative","Manager","Super Manager"];

let accountGradeList = [];
for(let i in ACCOUNTGRADE)
    accountGradeList.push({ID:i,Name:ACCOUNTGRADE[i]});

export { ACCOUNTGRADE,accountGradeList};